import VCAdhocReporting from './VCAdhocReporting';

export default VCAdhocReporting;
